import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import HostelPage from '../../views/HostelPage/';
const GLOBAL = require('../../Globals');

class Admission extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			modal: false,
			accyear : [],
			acyear : '',
			hlist : [],
			flist : [],
			rlist : [],
			idd : '',
			stdappno : '',
			stdregno : '',
			stdname : '',
			postFilter : [],
			loading: false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			alertClass :'',
			posts: []
			
		}
		this.toggle = this.toggle.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onappnoSearchChange = this.onappnoSearchChange.bind(this);
		this.onnameSearchChange = this.onnameSearchChange.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}

	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		this.getdata();
	}
	
	addtoggle(e){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	
	onChange(e){
		
		this.setState({[e.target.name] : e.target.value});
	}
	
	onRegnoSearchChange(e){
		
		this.state.stdregno = e.target.value;
		this.filterdata();
	}
	
	onnameSearchChange(e){
		
		this.state.stdname = e.target.value;
		this.filterdata();
	}
	
	onappnoSearchChange(e){
		
		this.state.stdappno = e.target.value;
		this.filterdata();
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({
			modal: !this.state.modal
		});
		this.gethostel();
		this.getfloors();
		this.getrooms();
		this.gethostdata();
		
	}
	
	gethostdata(){
		
		GetData('hostel/gethostelappsbyid/'+this.state.idd).then((result) => {
			let res = result;
			if(res){
				this.setState({
					hsname : res[0]['name'],
					hsappno : res[0]['applicationno']
				});
			}
		});
	}
	
	onSubmit(e){
		
		e.preventDefault();
		if(this.state!=''){
			
			PostData('hostel/addhostel',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Hostel Added Successfully!..',
						alertClass:'alert alert-success',
						modal: !this.state.modal
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("cform").reset();
					this.getdata();
				}
			});
		
		}
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('hostel/removehostel',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Hostel Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Hostel',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		this.setState({
			modal: !this.state.modal
		});
		$("#showLoader").show();
		if(this.state.idd){			
			PostData('hostel/allocateroom',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Room Allocated Successfully!..',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Room already full',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
				$("#showLoader").hide();
			});
		
		}
	
	}
	
	componentWillMount() {
		 
		this.getacyear();
		this.gethostel();
		this.filterdata();
	}

	/** get Academic Year **/
	getacyear(){
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
				this.getdata();
			}
		});
	}
	
	getdata(){
		this.setState({loading:true});
		this.setState({posts : []});
		GetData('student/getstdbyac/'+this.state.acyear).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson,
					loading:false
				});
			}
		});
	}
	
	gethostel(){
		
		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					hlist : responseJson
				});
				this.getfloors();
			}
		});
	}
	
	
	getfloors(){
		
		GetData('hostel/getfloorbyhostelid/'+this.state.hname).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					flist : responseJson
				});
				this.getrooms();
			}
		});
	}
	
	getrooms(){
		
		GetData('hostel/getroombyfloorid/'+this.state.hname+'/'+this.state.hfloor).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rlist : responseJson
				});

			}
		});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.posts.length; i++){
			
			if(this.state.stdregno!='' && this.state.stdappno=='' && this.state.stdname==''){
				
				if(this.state.posts[i].regno == this.state.stdregno){
					
					dat.push(this.state.posts[i]);
				}
			}
			if(this.state.stdappno=='' && this.state.stdregno=='' && this.state.stdname!=''){
				
				if(this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
					
					dat.push(this.state.posts[i]);
				}
			}
			
		}
		this.setState({postFilter : dat});
	}
	
  render() {
	  
	  
	  $("#hname").change(function(){
	
			var host = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getfloorbyhostelid/'+host,function(o){
				console.log(o);
				$("#hfloor").html('');
				$('#hfloor')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Floor- ')); 
				$.each(o,function(key,value){			
					   $('#hfloor')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
			
		
		});
		
		 $("#hfloor").change(function(){
			
			var host = $("#hname").val();
			var floor = $(this).val();
			$.get(GLOBAL.BASE_URL+'hostel/getroombyfloorid/'+host+'/'+floor,function(o){
				console.log(o);
				$("#hroom").html('');
				$('#hroom')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Floor- ')); 
				$.each(o,function(key,value){			
					   $('#hroom')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.name)); 	
											
				});	
				
			},'json');
			
		
		});
		
		var hnames = this.state.hlist;
		var fnames = this.state.flist;
		var rnames = this.state.rlist;
		var acyear = this.state.accyear;
	  
	  /** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item} style={{backgroundColor : item.ishostel == '1' ? '#f1c7c7' : ''}}>
				<td width="20">{i+1}</td>
				<td >{item.stdname}</td>
				<td>{item.regno}</td>
				<td style={{textTransform : 'uppercase'}}>{item.cls}</td>
				<td >{item.sec}</td>
				<td >{item.presentaddr}</td>
				<td >{item.mobile}</td>
				<td>
					<button name="edithw" disabled={item.ishostel == '1' ? true : false} className="btn btn-success btn-sm" onClick={() => this.onUpdate(item.regno)} ><i className="fa fa-check-circle"></i></button>
				</td>
			</tr>;
	});
	  
    return (
		<div>
		  <HostelPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			<Col md="12">
				<Card>
				  <CardHeader>
					<strong>Hostel Applications : &nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>&nbsp;&nbsp;</strong>
						Reg No : &nbsp;&nbsp;
							<input type="text" name="stdregno" onChange={this.onRegnoSearchChange} />&nbsp;&nbsp;
						Name : &nbsp;&nbsp;
							<input type="text" name="stdname" onChange={this.onnameSearchChange} />
				  </CardHeader>
				  <CardBody>
					<Row>
					  <Col md="12">
						<Table responsive>
						  <thead>
							<tr>
							  <th>S.No</th>
							  <th>Name</th>
							  <th>Register no</th>
							  <th>Class</th>
							  <th>Section</th>
							  <th>Address</th>
							  <th>Mobile</th>
							  <th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.loading ?  <tr><td colSpan="9"><center><Loader /></center></td></tr> : renderTodos}	
						</tbody>
						</Table>
					  </Col>
					  <Col md="4">
					  <Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.todosPerPage}
							pageRangeDisplayed={3}
							totalItemsCount={this.state.postFilter.length}
							onChange={this.handlePageChange}
						/>
					  </Col>
					   <Col md="2">
					 <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					</Col>
					  <Modal isOpen={this.state.modal} toggle={this.addtoggle} className={'modal-lg ' +this.props.className}>
						<form action="" method="post" role="form" id="chform" encType="multipart/form-data" onSubmit={this.onupdateSubmit}>
						  <ModalHeader toggle={this.toggle}>Hostel Admission -    Name : {this.state.hsname} &nbsp;Application No : {this.state.hsappno}</ModalHeader>
						  <ModalBody>
							<Row>
							   <Col md="3">
								<FormGroup>
									<Label>Hostel</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<select name="hname" className="form-control"  onChange={this.onChange} required id="hname">
										<option value="">Select Hostel</option>
										{
											hnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								</select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label>Floor</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<select name="hfloor" onChange={this.onChange} className="form-control" id="hfloor" required> 
										<option value="">Select Floors</option>
										{
											fnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								  </select>
								</FormGroup>
							  </Col>
							<Col md="3">
								<FormGroup>
									<Label>Rooms</Label>
								</FormGroup>
							  </Col>
							  <Col md="9">
								<FormGroup>
									<select name="hroom" onChange={this.onChange} className="form-control" id="hroom" required> 
										<option value="">Select Rooms</option>
										{
											rnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="success" >Allocate</Button>{' '}
							<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						  </ModalFooter>
						</form>
					  </Modal>
					</Row>
				  </CardBody>
				</Card>
			</Col>
		    </Row>
		    </div>
		</div>
    );
  }
}

export default Admission;



// WEBPACK FOOTER //
// ./src/hostel/HostelList/admission.js